
import api from "~api";
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Drawer from 'vux/src/components/drawer/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import ChinaAddressData from 'vux/src/datas/china_address.json'

import familyComponent from './family-component.vue'
export default {
components: {
XHeader,
Group,
Cell,
XInput,
XButton,
Selector,
Tabbar,TabbarItem,Drawer,ViewBox,
familyComponent,
Toast ,XAddress,ChinaAddressData
},
data () {
return {
addressData: ChinaAddressData,
btn:'btn',
disablebtn:'disablebtn',
stuinfo:{

},
info: [],
familyname:'',
familyrelate:'',
familyphone:'',
familyidcard:'',
familyjob:'',
familywork:'',
family:[
{
"guardian":"",
"relation":"",
"phone":"",
"guardianidentifyId":"",
"job":"",
"workplace":""
}








],
jiguan:'',
shengyuan:'',
options1: [{
key: '0',
value: '否'
}, {
key: '1',
value: '是'
}],
hukou: [{
key: '1',
value: '城镇户口'
}, {
key: '2',
value: '农村户口'
}, {
key: '3',
value: '其它'
}],
relations: [{
key: '1',
value: '父亲'
}, {
key: '2',
value: '母亲'
}, {
key: '3',
value:'其他'
}],
jobs: [{
key: '工人',
value: '工人'
}, {
key: '农民',
value: '农民'
}, {
key: '教师',
value:'教师'
}, {
key: '医生',
value: '医生'
}, {
key: '公务员',
value: '公务员'
}, {
key: '警察',
value:'警察'
}, {
key: '记者',
value: '记者'
}, {
key: '科学家',
value: '科学家'
}, {
key: '工程师',
value:'工程师'
}, {
key: '销售员',
value: '销售员'
}, {
key: '其他',
value: '其他'
}],
residence:{



},
showBool:false,
welBool:true,
skipBool:false,
editBool:false,
showtoast:false,
toasttext:'',
stunum: window.localStorage.getItem("stunum")
}
},
created() {
this.getData();
},
mounted () {
var flowdata = JSON.parse(window.localStorage.getItem('flowdata'));
var sort = this.$route.params.sort;
for (var i = 0;i<flowdata.length;i++){
if(flowdata[i].sort==sort){
if(flowdata[i].skip=='1'){
this.skipBool = true;
}else{
this.skipBool = false;
}
}
}

},
methods: {

checkType1(){
if(this.residence.migrateStatus == '' || this.residence.migrateStatus ==null){
this.toasttext = "市外是否有意愿迁移户口至学校";
this.showtoast=true;
return false;
}
return true;
},
checkType(){
if(this.residence.householdType == '' || this.residence.householdType ==null){
this.toasttext = "请选择户籍类型";
this.showtoast=true;
return false;
}
return true;
},
checkRel(){
for(var i=0;i<this.family.length;i++){
if(this.family[i]!=null && this.family[i]!={}){
if(this.family[i].relation == '' || this.family[i].relation ==null){
this.toasttext = "请选择关系";
this.showtoast=true;
return false;
}
}
if(i==this.family.length-1){
return true;
}
}

},
checkJg(){
if(this.residence.nativePlace == '' || this.residence.nativePlace ==null || this.residence.nativePlace == []){
this.toasttext = "请选择籍贯";
this.showtoast=true;
return false;
}
return true;
},
checkBirth(){
if(this.residence.students == '' || this.residence.students ==null || this.residence.students==[]){
this.toasttext = "请选择生源地";
this.showtoast=true;
return false;
}
return true;
},




















checkTel(){
for(var i=0;i<this.family.length;i++){
if(this.family[i]!=null && this.family[i]!={}){
var telreg = /^(((12[0-9]{1})|(13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/;
if(this.family[i].phone == '' || this.family[i].phone ==null){
this.toasttext = "请输入手机号码";
this.showtoast=true;
return false;
}else if (!telreg.test(this.family[i].phone)){
this.toasttext = "请输入正确的手机号码";
this.showtoast=true;
return false;
}
}
if(i==this.family.length-1){
return true;
}
}

},
checkMyTel(){
var telreg = /^(((12[0-9]{1})|(13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/;
if(this.residence.stuPhone == '' || this.residence.stuPhone ==null || this.residence.stuPhone == undefined){
this.toasttext = "请输入手机号码";
this.showtoast=true;
return false;
}else if (!telreg.test(this.residence.stuPhone)){
this.toasttext = "请输入正确的手机号码";
this.showtoast=true;
return false;
}
return true;

},
checkJob(){
for(var i=0;i<this.family.length;i++){
if(this.family[i]!=null && this.family[i]!={}){
if(this.family[i].job == '' || this.family[i].job ==null){
this.toasttext = "请输入职业";
this.showtoast=true;
return false;
}
}
if(i==this.family.length-1){
return true;
}
}

},
checkPlace(){
for(var i=0;i<this.family.length;i++){
if(this.family[i]!=null && this.family[i]!={}){
if(this.family[i].workplace == '' || this.family[i].workplace ==null){
this.toasttext = "请输入单位";
this.showtoast=true;
return false;
}
}
if(i==this.family.length-1){
return true;
}
}

},
checkName(){
for(var i=0;i<this.family.length;i++){
if(this.family[i]!=null && this.family[i]!={}){
if(this.family[i].guardian == '' || this.family[i].guardian ==null){
this.toasttext = "请输入姓名";
this.showtoast=true;
return false;
}
}
if(i==this.family.length-1){
return true;
}
}

},
getData(){

api.post("/api/NewReports/findInformation", {"stuCode": window.localStorage.getItem("stuCode")}).then( res=>{
if(res.status==200){
this.stuinfo = res.data.results[0];
if(this.stuinfo.gender=="1"){
this.$set(this.stuinfo,"sex","男")
}else{
this.$set(this.stuinfo,"sex","女")
}
api.post("/api/NewReports/findFamily", {"stuCode": window.localStorage.getItem("stuCode")}).then( res=>{
if(res.data.results.length>0){
this.editBool = true;
this.residence = res.data.results[0];
this.family = res.data.results;
this.residence.nativePlace = res.data.results[0].nativePlace.split(",");

}
})
}
})
},

goNext () {
var _this = this;
var flowdata = JSON.parse(window.localStorage.getItem('flowdata'));
var sort = _this.$route.params.sort;
var urlname = '';
var stunum = _this.$route.params.stunum;
for (var i = 0;i<flowdata.length;i++){
if(flowdata[i].sort>sort){
sort = flowdata[i].sort;
urlname = flowdata[i].urlname;
_this.$router.push({name: urlname,params:{sort:sort,stunum:stunum,skip:flowdata[i].skip}});
return;
}/*else{
_this.$router.push({name: 'generateform',params:{stunum:stunum}});
}*/
}
},
addfamily(){
this.family.push({

})
},
deletefamily(index){
if(this.family.length>1){
this.family.splice(index,1)
}else{
this.$msgbox('温馨提示：',"家庭成员信息至少需要保留一位！");
}
},
onSubmit(){
if( this.checkMyTel() && this.checkJg() && this.checkName() &&  this.checkRel() && this.checkTel() && this.checkJob() && this.checkPlace() ){

var info = [];
for(var i=0;i<this.family.length;i++){
if(this.family[i]!=null && this.family[i]!={}){
var li = {};








this.$set(li,"guardian",this.family[i].guardian);
this.$set(li,"relation",this.family[i].relation);
this.$set(li,"phone",this.family[i].phone);

this.$set(li,"job",this.family[i].job);
this.$set(li,"workplace",this.family[i].workplace);
this.$set(li,"stuCode",window.localStorage.getItem("stuCode"));
this.$set(li,"processId",this.$route.params.sort);


this.$set(li,"nativePlace",this.residence.nativePlace.join(","));
this.$set(li,"stuPhone",this.residence.stuPhone);


this.info.push(li);
}
}

if(this.editBool){
console.log("edit===="+JSON.stringify(this.info))
api.post("/api/NewReports/updateNewReports", {"info":JSON.stringify(this.info)}).then( res=>{
if(res.data!=null){
if(res.data.results){
this.goNext();
}else{
this.$msgbox('温馨提示：',"信息修改失败！");
}
}
})
}else{
console.log("save===="+JSON.stringify(this.info))
api.post("/api/NewReports/addNewReports", {"info":JSON.stringify(this.info)}).then( res=>{
if(res.data!=null){
if(res.data.results){
this.goNext();
}else{
this.$msgbox('温馨提示：',"信息保存失败！");
}
}
})
}
}
}

}
}



// WEBPACK FOOTER //
// ./src/components/newstu/personalinformation.vue